import { get, values, groupBy, head, keys, forIn } from 'lodash'
import moment from 'moment'

export default class DataMapper {
  static objectsById = (objects = []) => {
    return objects.reduce((result, object) => {
      return {
        ...result,
        [object.uuid || object.id]: object
      }
    }, {})
  }

  static objectIdsByAttribute = (objects = [], attribute) => {
    return objects.reduce((result, object) => {
      const typeId = object[attribute]
      const objectId = object.id || object.uuid

      if (result[typeId]) {
        return {
          ...result,
          [typeId]: [...result[typeId], objectId]
        }
      } else {
        return {
          ...result,
          [typeId]: [objectId]
        }
      }
    }, {})
  }

  static staffByStandUuids = (objects = []) => {
    return objects.reduce((result, object) => {
      const typeIds = get(object, 'configuration.standUuids') || []
      const objectId = object.employeeUuid
      let obj = result

      typeIds.forEach(id => {
        if (result[id]) {
          obj = {
            ...obj,
            [id]: [...result[id], objectId]
          }
        } else {
          obj = {
            ...obj,
            [id]: [objectId]
          }
        }
      })
      return obj
    }, {})
  }

  static eventsMapper(events) {
    const eventsData = []
    const grouped = groupBy(events, (event) => head(/[0-9]{4}-[0-9]{2}/.exec(event.startTime)))

    keys(grouped).forEach((eventMonth, eventMonthIndex) => {
      grouped[eventMonth] = grouped[eventMonth].sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
      const groupedEvents = values(groupBy(grouped[eventMonth], (event) => moment(event.startTime).format('YYYY-MM-DD')))

      eventsData.push({ id: eventMonthIndex, date: head(grouped[eventMonth]).startTime, days: [] })

      groupedEvents.forEach((eventDay, eventDayIndex) => {
        eventsData[eventMonthIndex].days.push({ id: eventDayIndex, date: head(eventDay).startTime, events: eventDay })
      })
    })

    const sortedEvents = eventsData.sort((a, b) => new Date(a.date) - new Date(b.date))

    return sortedEvents
  }

  static byEventAndEmployeeId(configs, recalculateStandUuuids = true) {
    const configData = {}
    configs.forEach(config => {
      if(!configData[config.salesEventId]) {
        configData[config.salesEventId] = { byEmployeeId: {} }
      }
      configData[config.salesEventId]['byEmployeeId'][config.employeeUuid] = config
    });

    if(recalculateStandUuuids) {
      forIn(configData, (eventValues, salesEventId) => {
        const byStandUuid = configData[salesEventId]['byStandUuid']
        configData[salesEventId]['byStandUuid'] = {
          ...byStandUuid,
          ...this.staffByStandUuids(values(eventValues.byEmployeeId))
        }
      })
    }
    return configData
  }

}
